import React from 'react';
interface Column {
  key: string;
  header: string;
  render?: (value: any, row: any) => React.ReactNode;
}
interface TableProps {
  columns: Column[];
  data: any[];
  emptyMessage?: string;
}
export function Table({
  columns,
  data,
  emptyMessage = 'No data available'
}: TableProps) {
  if (data.length === 0) {
    return <div className="bg-white rounded-lg border border-gray-200 p-8 text-center" data-id="element-330">
        <p className="text-gray-500" data-id="element-331">{emptyMessage}</p>
      </div>;
  }
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-332">
      <div className="overflow-x-auto" data-id="element-333">
        <table className="w-full" data-id="element-334">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-335">
            <tr data-id="element-336">
              {columns.map(column => <th key={column.key} className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-337">
                  {column.header}
                </th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-338">
            {data.map((row, index) => <tr key={index} className="hover:bg-gray-50 transition-colors" data-id="element-339">
                {columns.map(column => <td key={column.key} className="px-6 py-4 text-sm text-gray-900" data-id="element-340">
                    {column.render ? column.render(row[column.key], row) : row[column.key]}
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}